var App = App || {};

App.ComponentAlerts = (function ($) {
    'use strict';

    function Close() {
        var alerts = $(".component-alerts").find(".alert");
        alerts.each(function (index, alert) {
            $(alert).on("closed.bs.alert", function () {
                const guid = $(alert).attr("data-guid");
                const cookieName = `BeaconBank_Alert_${guid}`;
                App.Cookies.setItem(cookieName, "Dismissed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
            })
        });
    }

    return {
        Close: Close
    };

})(jQuery);